import { Datepicker } from "@mobiscroll/react";
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import AsyncTypeahead, { DataListType } from "../../../components/AsyncTypeahead";
import { ToastConfig } from "../../../components/Toaster";
import '../../../assets/scss/custom/_custom.scss';
import { createMedicationApi, createPatientApi } from "../../../api-helpers/PatientApiHelper";
import { GetPatientMedicationMapping, PatientMedicationRequest, UpdatePatientMappingRequest } from "patients-experience-client";
import { Lookup } from "common-util-experience-client";
import Lookups from "../../../constants/Lookups";
import { createCommonUtilsApi } from "../../../api-helpers/CommonUtilsApiHelper";
import Spinner from "../../../components/Spinner";

interface AddMedicationProps {
  patientId: string,
  setOffCanvasShow: React.Dispatch<React.SetStateAction<boolean>>;
  reloadGrid: () => void;
  onSubmitMedication: (toasterConfig: ToastConfig) => void,
  selectedMedication?: any;
}

export const AddMedication: React.FC<AddMedicationProps> = ({ patientId, setOffCanvasShow, reloadGrid, onSubmitMedication, selectedMedication }) => {
  const medicationApi = createMedicationApi();
  const patientApi = createPatientApi();
  const apiLookup=createCommonUtilsApi()


  const [loading, setloading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [medicationForm, setMedicationForm] = useState<PatientMedicationRequest>({} as PatientMedicationRequest);
  const [medicationApiResponse, setMedicationApiResponse] = useState({} as GetPatientMedicationMapping);
  const [medications, setMedications] = useState<Array<DataListType>>([]);
  const [defaultMedication, setDefaultMedication] = useState<string>("");
  const [validMedications, setValidMedications] = useState<boolean>(true);
  const [validMedicine, setValidMedicine] = useState<boolean>(true);
  const [medicationStatus, setMedicationStatus] = useState<Lookup[]>([]);
  const [medicationReconcialiationStatus, setMedicationReconcialiationStatus] = useState<Lookup[]>([]);
  const [validated, setValidated] = useState(false);
  const [fromDatePicker, setFromDatePicker] = useState<boolean>(false);
  const [toDatePicker, setToDatePicker] = useState<boolean>(false);
  const [lastFilledDatePicker, setLastFilledDatePicker] = useState<boolean>(false);
  const [preScribedDatePicker, setPreScribedDatePicker] = useState<boolean>(false);

  const getMedicationStatus = async () => {
    setloading(true);
    try {
        const response = await apiLookup.lookupControllerFindAll(Lookups.MEDICATION_STATUS);
        await setMedicationStatus(response.data.sort((a: Lookup, b: Lookup) => a.sequence - b.sequence));
        setloading(false);
    } catch (error) {
      setloading(false);
      console.log(error);
    } 
  };

  const getMedicationReconcialiationStatus = async () => {
    try {
        const response= await apiLookup.lookupControllerFindAll(Lookups.MEDICATION_RECONCILIATION_STATUS);
        setMedicationReconcialiationStatus(response.data.sort((a:Lookup, b:Lookup) => a.sequence - b.sequence));
    } catch (error) {
      console.log(error);
    } 
  };

  const getMedicationDetailsById = async () => {
    
    const medicationId = selectedMedication && selectedMedication.medicationId!
    if (medicationId) {
      setloading(true);
      try {
        const medicationResponse= await patientApi.patientsControllerGetMedicationById(patientId, medicationId);
        const medication = medicationResponse.data;
        console.log('medication data : ',medication);
        
        await setMedicationApiResponse(medication);
        await setMedicationForm({
          patientId: medication.patientId,
          medicationId: selectedMedication.medicationId!,
          medicationStartDate: medication.medicationStartDate!,
          medicationEndDate: medication.medicationEndDate!,
          prescribedBy: medication.prescribedBy!,
          prescribedAt: medication.prescribedAt!,
          filledAt: medication.lastFilled,
          quantityDispensed: parseInt(medication.dispensed),
          status: medication.status!,
          medRecStatus: medication.medRecStatus,
          dosageRecommended: medication.dosage!,
          instructions: medication.instructions!,
          lastFilled: medication.lastFilled!,
          route: medication.medicationRoute!,
          frequency: medication.medicationFrequency!,
          addedBy: medication.addedBy!,
          isDeleted: false,
          refills: medication.refills,
          schedule: '',
          dispensed: medication.dispensed,
        });
        setloading(false);
      } catch (error) {
        console.log(error);
        setloading(false);
      }
    }
  };

  useEffect(() => {
    if(selectedMedication){
      getMedicationDetailsById();
    }
    setloading(true);
    getMedicationStatus();
    getMedicationReconcialiationStatus();
    setloading(false);
  }, [])

  const loadMedications = async (query: string) => {
    if (!query) {
      setMedications([]);
      return;
    }
    try {
      const response = await medicationApi.medicationControllerSearchMedication(query);
      const options: DataListType[] = response.data.map((item: any) => ({
        key: item.id,
        value: item.medicationName,
      }));
      setMedications(options);
    } catch (error) {
      console.log(error);
    }
  };

  const selectMedication = (selected: any) => {
    setMedicationForm(medicationForm => ({
      ...medicationForm,
      medicationId: selected && selected.key
    }));
  };


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const statusvar = 'status';

    setMedicationForm(medicationForm => ({
      ...medicationForm,
      [name]: type === 'radio' ? (value.toLowerCase() === 'active' ? true : false) : value
    }));

    if (type === 'radio') {

      setMedicationForm(medicationForm => ({
        ...medicationForm,
        [statusvar]: value.toLowerCase() === 'active' ? 'active' : 'inactive'
      }));
    }
  };

  const dateChangeHandler = (name: string, event: any) => {
    setMedicationForm(medicationForm => ({
      ...medicationForm,
      [name]: event.value
    }));
  };

  const handleDiscard = () => {
    setOffCanvasShow(false);
  };

  const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setValidated(true);
    setIsProcessing(true)
    const form = event.currentTarget;
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      setIsProcessing(false)
      return;
    }
    await setValidMedications(true);
    await setValidMedicine(true);
    if (!medicationForm.medicationId) {
      !medicationForm.medicationId && setValidMedicine(false);
      return;
    }
    setloading(true);

    // const updateData = {
    //   ...medicationForm,
    //   medicationId: medicationApiResponse.medication.id || "",
    //   route: selectedMedication.medicationRoute.id|| "",
    //   frequency: selectedMedication.medicationFrequencyName.id || "",
    // }
    const updateDataForm:UpdatePatientMappingRequest = {
      medicationId: medicationForm.medicationId|| "",
      route: medicationForm.route || "",
      frequency: medicationForm.frequency || "",
      medicationStartDate: medicationForm.medicationStartDate,
      medicationEndDate: medicationForm.medicationEndDate,
      prescribedAt: medicationForm.prescribedAt,
      lastFilled: medicationForm.lastFilled,
      prescribedBy: medicationForm.prescribedBy!,
      dispensed: medicationForm.dispensed,
      instructions: medicationForm.instructions,
      dosageRecommended: medicationForm.dosageRecommended,
      status: medicationForm.status,
      medRecStatus: medicationForm.medRecStatus,
      addedBy: medicationForm.addedBy,
      isDeleted: false,
      refills: Number(medicationForm.refills)
    }
    try {
      const saveMedicationForm = {
        ...medicationForm,
        patientId: patientId,
        refills: Number(medicationForm.refills),
        isDeleted: false,
      };
      setMedicationForm(saveMedicationForm);
    let medicationResponse;
      if(selectedMedication){
        medicationResponse = await patientApi.patientsControllerUpdateMedication(updateDataForm, patientId, selectedMedication.id);
      } else {
        medicationResponse =  await patientApi.patientsControllerAddMedication(saveMedicationForm, patientId);
      }
      // const response = await patientApi.patientsControllerAddMedication(updatedMedicationForm, patientId);
      setloading(false);
      showSuccessMessage(medicationResponse.data);
    } catch (error) {
      setloading(false);
      showErrorMessage();
    } finally {
      setIsProcessing(false)
    }
  };

  const showSuccessMessage = (res: any) => {
    if (res.statusCode === 403) {
      const toasterConfig: ToastConfig = {
        type: "danger",
        title: res.message,
        icon: "error_outline",
      };
      onSubmitMedication(toasterConfig as ToastConfig);
    } else {
      const toasterConfig: ToastConfig = {
        type: "success",
        title: res.message,
        icon: "check_circle_outline",
      };
      onSubmitMedication(toasterConfig as ToastConfig);
      handleDiscard();
      reloadGrid();
    }
  }

  const showErrorMessage = () => {
    // setShowToast(false);
    const toasterConfig: ToastConfig = {
      type: "danger",
      title: "Error while adding medication!",
      icon: "error_outline",
    };
    onSubmitMedication(toasterConfig as ToastConfig);

  }

  return (
    <>
      {loading && <Spinner />}
      <Form
        className="d-flex flex-column h-100"
        noValidate
        validated={validated}
        onSubmit={submitHandler}
      >
        <div className="flex-fill">
          <div className="row g-2">
            <div className="col-12 mb-3">
              <label className="form-label fs-12 fw-semibold mb-1">Medicine</label>
              {
              selectedMedication ? 
              <input
                type="text"
                className="form-control"
                value={selectedMedication.medicationName} // Assuming `name` is a field in patientDetails
                disabled
              /> :
                <AsyncTypeahead
                  name="medicationId"
                  options={medications}
                  callback={loadMedications}
                  onSelect={selectMedication}
                  placeholder={"Add Medication"}
                  defaultValue={defaultMedication}
                  required={true}
                  isValid={validMedicine}
                ></AsyncTypeahead>
              }
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="dosage" className="form-label fs-12 fw-semibold mb-1">Dosage</label>
              {/* <select id="dosage" className="form-select form-select-sm" name="dosageRecommended" required value={medicationForm.dosageRecommended} onChange={handleInputChange}>
                <option value="" selected>Select</option>
                <option value="One (10 mg)">One (10 mg)</option>
                <option value="Two (20 mg)">Two (20 mg)</option>
                <option value="Half (5 mg)">Half (5 mg)</option>
              </select> */}
              <input type="text"
                id="dosage" 
                value={medicationForm.dosageRecommended} 
                placeholder="Dosage" 
                className="form-control form-control-sm"
                name="dosageRecommended" onChange={handleInputChange}
              />
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="route" className="form-label fs-12 fw-semibold mb-1">Route</label>
              <input type="text"
                id="route" 
                value={medicationForm.route} 
                placeholder="Route" 
                className="form-control form-control-sm"
                name="route" onChange={handleInputChange}
              />
            </div>
            <div className="col-12 mb-3">
              <label className="form-label fs-12 fw-semibold mb-1">Status</label>
              <div className="border rounded px-3 py-1">
                {
                  medicationStatus.map((status: Lookup, index: number) => (
                    <div key={index} className={`form-check form-check-inline ${index ? 'me-2':''}`}>
                      <div>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="status"
                          id={`statusRadio${index}`}
                          value={status.id}
                          checked={medicationForm.status === status.id? true : false}
                          onChange={(e) => setMedicationForm({...medicationForm, status: e.target.value })}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`statusRadio${index}`}
                        >
                          {status.name}
                        </label>
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            <div className="col-12 mb-3">
              <label className="form-label fs-12 fw-semibold mb-1">Medication Reconciliation Status</label>
              <div className="border rounded px-3 py-1">
                {
                  medicationReconcialiationStatus.map((status: Lookup, index: number) => (
                    <div key={index} className={`form-check form-check-inline ${index ? 'me-2':''}`}>
                      <div>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="medRecStatus"
                          id={`medRecStatus${index}`}
                          value={status.id}
                          checked={medicationForm.medRecStatus === status.id? true : false}
                          onChange={(e) => setMedicationForm({...medicationForm, medRecStatus: e.target.value })}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`medRecStatus${index}`}
                        >
                          {status.name}
                        </label>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="medicationStartDate" className="form-label fs-12 fw-semibold mb-1">From Date</label>
              <div className="mobiscroll">
                <div className="mobiscroll__calendar">
                  <Datepicker
                    id="medicationStartDate"
                    value={medicationForm.medicationStartDate}
                    controls={["calendar"]}
                    calendarType="month"
                    theme="windows"
                    themeVariant="light"
                    placeholder="MM/DD/YYYY"
                    display="bubble"
                    touchUi={true}
                    showOnClick={false}
                    isOpen={fromDatePicker}
                    onClose={() => {setFromDatePicker(false)}}
                    buttons={[]}
                    onChange={(e) => dateChangeHandler('medicationStartDate', e)}
                  />
                </div>
                    <div onClick={() => setFromDatePicker(!fromDatePicker)} className="mobiscroll__calendar-icon">
                        <span className="material-symbols-outlined fs-18" >
                          calendar_month
                        </span>
                    </div>
              </div>
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="medicationEndDate" className="form-label fs-12 fw-semibold mb-1">To Date</label>
              <div className="mobiscroll">
                <div className="mobiscroll__calendar">
                  <Datepicker
                    id="medicationEndDate"
                    value={medicationForm.medicationEndDate}
                    controls={["calendar"]}
                    calendarType="month"
                    theme="windows"
                    themeVariant="light"
                    placeholder="MM/DD/YYYY"
                    display="bubble"
                    min={medicationForm.medicationStartDate}
                    touchUi={true}
                    showOnClick={false}
                    isOpen={toDatePicker}
                    onClose={() => {setToDatePicker(false)}}
                    buttons={[]}
                    onChange={(e) => dateChangeHandler('medicationEndDate', e)}
                  />
                </div>
                    <div onClick={() => setToDatePicker(!toDatePicker)} className="mobiscroll__calendar-icon">
                        <span className="material-symbols-outlined fs-18" >
                          calendar_month
                        </span>
                    </div>
              </div>
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="frequency" className="form-label fs-12 fw-semibold mb-1">Frequency</label>
              <input type="text"
                id="frequency" 
                value={medicationForm.frequency} 
                placeholder="Frequency" 
                className="form-control form-control-sm"
                name="frequency" onChange={handleInputChange}
              />
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="refills" className="form-label fs-12 fw-semibold mb-1">No. of refills</label>
              <input type="text" id="refills" value={medicationForm.refills} placeholder="No. of refills" className="form-control form-control-sm" name="refills" onChange={handleInputChange} />
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="dispensed" className="form-label fs-12 fw-semibold mb-1">Dispensed</label>
              <input type="text" name="dispensed" id="dispensed" value={medicationForm.dispensed as string} placeholder="Dispensed" className="form-control form-control-sm" onChange={handleInputChange} />
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="lastFilled" className="form-label fs-12 fw-semibold mb-1">Last Filled</label>
              <div className="mobiscroll">
                <div className="mobiscroll__calendar">
                  <Datepicker
                    id="lastFilled"
                    value={medicationForm.lastFilled}
                    controls={["calendar"]}
                    calendarType="month"
                    theme="windows"
                    themeVariant="light"
                    placeholder="MM/DD/YYYY"
                    max={new Date()}
                    display="bubble"
                    touchUi={true}
                    showOnClick={false}
                    isOpen={lastFilledDatePicker}
                    onClose={() => {setLastFilledDatePicker(false)}}
                    buttons={[]}
                    onChange={(e) => dateChangeHandler('lastFilled', e)}
                  />
                </div>
                   <div onClick={() => setLastFilledDatePicker(!lastFilledDatePicker)} className="mobiscroll__calendar-icon">
                      <span className="material-symbols-outlined fs-18" >
                        calendar_month
                      </span>
                    </div>
              </div>
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="prescribedBy" className="form-label fs-12 fw-semibold mb-1">Prescribed By</label>
              <input type="text" name="prescribedBy" id="prescribedBy" value={medicationForm.prescribedBy} placeholder="Prescribed By" className="form-control form-control-sm" onChange={handleInputChange} />
            </div>
            <div className="col-6 mb-3">
              <label htmlFor="prescribedOn" className="form-label fs-12 fw-semibold mb-1">Prescribed On</label>
              <div className="mobiscroll">
                <div className="mobiscroll__calendar">
                  <Datepicker
                    id="prescribedOn"
                    value={medicationForm.prescribedAt}
                    controls={["calendar"]}
                    calendarType="month"
                    theme="windows"
                    themeVariant="light"
                    placeholder="MM/DD/YYYY"
                    max={new Date()}
                    display="bubble"
                    touchUi={true}
                    showOnClick={false}
                    isOpen={preScribedDatePicker}
                    onClose={() => {setPreScribedDatePicker(false)}}
                    buttons={[]}
                    onChange={(e) => dateChangeHandler('prescribedAt', e)}
                  />
                </div>
                  <div onClick={() => setPreScribedDatePicker(!preScribedDatePicker)} className="mobiscroll__calendar-icon">
                      <span className="material-symbols-outlined fs-18" >
                        calendar_month
                      </span>
                  </div>
              </div>
            </div>
            <div className="col-12 mb-3">
              <label htmlFor="instructions" className="form-label fs-12 fw-semibold mb-1">Instructions</label>
              <textarea id="instructions" 
                name="instructions" 
                value={medicationForm.instructions} 
                className="form-control form-control-sm" 
                placeholder="Type instructions.." 
                rows={3} 
                onChange={handleInputChange}>
              </textarea>
            </div>
          </div>
        </div>
        <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
          <button className="btn btn-sm btn-outline-secondary rounded-pill px-5 fs-13" type="button" onClick={handleDiscard}>
            Discard
          </button>
          <button 
            className="btn btn-sm btn-secondary rounded-pill ps-4 pe-5 fs-13" 
            type="submit"
            disabled={isProcessing}
          >
            <span className="material-symbols-outlined fs-16 align-text-top me-1">
            {isProcessing ? "" : selectedMedication ? ""  : "add"}
              </span>
              {isProcessing ? "Processing..." : selectedMedication ? "Update" : "Add"}
          </button>
        </div>
      </Form>
    </>
  );
};